import { render, staticRenderFns } from "./qualityControl.vue?vue&type=template&id=58045d25&scoped=true"
import script from "./qualityControl.vue?vue&type=script&lang=js"
export * from "./qualityControl.vue?vue&type=script&lang=js"
import style0 from "./qualityControl.vue?vue&type=style&index=0&id=58045d25&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58045d25",
  null
  
)

export default component.exports